import { useEffect } from "react";

const ProviderLogin = ({loginCode}) => {

  useEffect(() => {
    if (loginCode) {
      localStorage.setItem("loginCode", loginCode);
    }
    let new_window = window.open(window.location.href, '_self');
    new_window.close();
  }, [loginCode]);

  return null
};

export default ProviderLogin;


// WEBPACK FOOTER //
// ./src/components/provider-login/index.jsx